import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-drilling-black"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"44\" height=\"44\" class=\"icon-fi--no-fill icon-fi--filled\"></rect><g transform=\"translate(6.38 6.23)\" class=\"\"><g transform=\"translate(12.121 3.68)\" class=\"\"><path d=\"M0.2-1.9v7.6L1.6,9l5.1-9.2v-1.7H0.2z\" class=\"icon-fi--filled\"></path><path d=\"M6.4,17.4c0-2.7-0.3-4.1-1-5.2l-3.2,6.5l1.5,1.6L6.4,17.4z\" class=\"icon-fi--filled\"></path><path d=\"M0.3,12.7v3.9l1.3,1l4.9-9c0-3.2-0.2-4.5-1-5.7L0.3,12.7z\" class=\"icon-fi--filled\"></path></g><path d=\"M28.2,9.2h-8.4l0,13.6c0,3.3-2,5.9-4.4,5.9S11,26.1,11,22.8l0-13.6H2.6\" class=\"icon-fi--stroke-linecap-round icon-fi--no-fill icon-fi--with-stroke\"></path></g>", 2)
  ]), 16))
}
export default { render: render }